import React from 'react';

import ModalFooter from 'CommonComponents/ModalFooter';
import ModalHeader from 'CommonComponents/ModalHeader';

const SimpleConfirmationModal = ({ showCancelButton = true, showSubmitButton = true, ...props }) => {
    const internalCloseHandler = () => {
        props.closeHandler && typeof props.closeHandler === 'function' && props.closeHandler();
    };

    const internalSuccessHandler = () => {
        props.successHandler && typeof props.successHandler === 'function' && props.successHandler();
    };

    const close = () => {
        internalCloseHandler();
        props.modalElement.hide();
    };

    return (
        <div id={props.modalId} ref={props.modalRef} tabIndex="-1" aria-hidden="true" className="hidden modal__box">
            <div className="modal__container">
                <div className="modal__inner-container">
                    <ModalHeader title={$t(props.title)} close={close}></ModalHeader>
                    <div className="tw-rounded-b">
                        {props.allowAction && (
                            <div className="modal__form-container">
                                <p className="modal__msg modal__text-color">{props.confirmationMsg}</p>
                                <ModalFooter
                                    allowCancel={showCancelButton}
                                    allowSubmit={showSubmitButton}
                                    cancelButtonText={$t(props.cancelButtonText)}
                                    primaryButtonText={$t(props.primaryButtonText)}
                                    onCancel={close}
                                    handleSubmit={internalSuccessHandler}
                                ></ModalFooter>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default React.memo(SimpleConfirmationModal);
